/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Term_L3Inputs */

const en_mk_term_l3 = /** @type {(inputs: Mk_Term_L3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`✖ AC-1 test   3.1s  pnpm test — 2 failed`)
};

const id_mk_term_l3 = /** @type {(inputs: Mk_Term_L3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`✖ AC-1 test   3.1s  pnpm test — 2 gagal`)
};

/**
* | output |
* | --- |
* | "✖ AC-1 test 3.1s pnpm test — 2 failed" |
*
* @param {Mk_Term_L3Inputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_term_l3 = /** @type {((inputs?: Mk_Term_L3Inputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Term_L3Inputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_term_l3(inputs)
	return en_mk_term_l3(inputs)
});